import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { updateLayout } from 'PreviewActions';
import { getAvailableLayouts, getSelectedLayout } from 'PreviewSelectors';
import LayoutRecord from 'PreviewRecords/LayoutRecord';
import LayoutSelector from 'PreviewComponents/SideBar/LayoutSelector/LayoutSelector';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';

const PanelContents = styled.div`
  position: relative;
  margin-top: 5px;
  padding: 5px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding: 0px 0 0 10px;
`;

class PagePanel extends Component {
  componentWillMount() {
    const { activeLayout, availableLayouts, updateLayout } = this.props;
    if (!activeLayout) {
      if (availableLayouts.first()) {
        updateLayout(availableLayouts.first().key);
      } else {
        updateLayout(null);
      }
    }
  }
  render() {
    const { availableLayouts, activeLayout } = this.props;

    return (
      <PanelContents>
        <Row>
          <WveStyleElementLabel
            key=""
            label={'layouts'}
          />
        </Row>
        <LayoutSelector
          availableLayouts={availableLayouts}
          activeLayout={activeLayout}
        />
      </PanelContents>
    );
  }
}

PagePanel.propTypes = {
  activeLayout: PropTypes.instanceOf(LayoutRecord),
  availableLayouts: PropTypes.object.isRequired,
  updateLayout: PropTypes.func,
};

PagePanel.defaultProps = {
  activeLayout: null,
  availableLayouts: {},
  updateLayout: () => {},
};

const mapStateToProps = state => ({
  availableLayouts: getAvailableLayouts(state),
  activeLayout: getSelectedLayout(state),
});

const mapDispatchToProps = dispatch => ({
  updateLayout: layout =>
    dispatch(updateLayout(layout)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PagePanel);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/Panels/Containers/PagePanel.jsx